import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

const navItems = [
  { path: '/vacancies', label: 'Вакансии', icon: 'ri-briefcase-line' },
  { path: '/candidates', label: 'Кандидаты', icon: 'ri-user-search-line' },
  { path: '/sourcing', label: 'Sourcing', icon: 'ri-radar-line' },
  { path: '/interviews', label: 'Интервью', icon: 'ri-calendar-check-line' },
  { path: '/emails', label: 'Письма', icon: 'ri-mail-line' },
  { path: '/scoring', label: 'Скоринг', icon: 'ri-bar-chart-box-line' },
  { path: '/portrait', label: 'Портрет', icon: 'ri-user-star-line' },
  { path: '/hhru', label: 'hh.ru', icon: 'ri-global-line' },
  { path: '/members', label: 'Участники', icon: 'ri-team-line' },
  { path: '/organizations', label: 'Организации', icon: 'ri-organization-chart' },
];

export default function Sidebar() {
  const { user, orgName, orgId, switchOrg, logout, isDemo } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <aside className="w-64 h-screen bg-background-50 border-r border-background-200 flex flex-col fixed left-0 top-0 z-40">
      {/* Logo */}
      <div className="px-5 py-6 border-b border-background-200">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
            <span className="text-white font-heading font-bold text-sm">H</span>
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <span className="font-heading font-bold text-foreground-950 text-base leading-tight">HR.Starec</span>
              {isDemo && (
                <span className="shrink-0 text-[10px] font-semibold bg-accent-500 text-white px-1.5 py-0.5 rounded-full">
                  DEMO
                </span>
              )}
            </div>
            <p className="text-[11px] text-foreground-400 leading-tight mt-0.5">AI-платформа подбора</p>
          </div>
        </div>
      </div>

      {/* Org Switcher */}
      {user && user.organizations.length > 1 && (
        <div className="px-4 py-3 border-b border-background-200">
          <label className="text-[10px] uppercase tracking-wider text-foreground-400 font-medium mb-1.5 block">
            Организация
          </label>
          <select
            value={orgId || ''}
            onChange={(e) => switchOrg(e.target.value)}
            className="w-full text-sm bg-background-100 border border-background-200 rounded-md px-2.5 py-1.5 text-foreground-800 focus:outline-none focus:ring-1 focus:ring-primary-400 cursor-pointer"
          >
            {user.organizations.map((org) => (
              <option key={org.id} value={org.id}>{org.name}</option>
            ))}
          </select>
        </div>
      )}
      {user && user.organizations.length === 1 && (
        <div className="px-4 py-3 border-b border-background-200">
          <label className="text-[10px] uppercase tracking-wider text-foreground-400 font-medium mb-1 block">
            Организация
          </label>
          <p className="text-sm text-foreground-700 font-medium truncate">{orgName || user.organizations[0]?.name}</p>
        </div>
      )}

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto py-3 px-3">
        <ul className="space-y-0.5">
          {navItems.map((item) => {
            const isActive = location.pathname.startsWith(item.path);
            return (
              <li key={item.path}>
                <button
                  onClick={() => navigate(item.path)}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    isActive
                      ? 'bg-primary-500 text-white'
                      : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-900'
                  }`}
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className={`${item.icon} ${isActive ? 'text-white' : 'text-foreground-400'}`}></i>
                  </span>
                  {item.label}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* User & Logout */}
      <div className="border-t border-background-200 p-4">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
            <span className="text-accent-700 font-heading font-semibold text-xs">
              {user?.name?.charAt(0)?.toUpperCase() || 'U'}
            </span>
          </div>
          <div className="min-w-0">
            <p className="text-sm font-medium text-foreground-800 truncate">{user?.name || 'Пользователь'}</p>
            <p className="text-[11px] text-foreground-400 truncate">{user?.email}</p>
          </div>
        </div>
        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-foreground-500 hover:text-red-600 hover:bg-red-50 transition-colors cursor-pointer whitespace-nowrap"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-logout-box-r-line"></i>
          </span>
          Выйти
        </button>
      </div>
    </aside>
  );
}